'use strict';

var cov_1jr5bbbztl = function () {
  var path = '/home/rwaltenberg/Projects/moneycounter/src/index.js',
      hash = 'cc19aa2b44edeeb6f1aa3c5fba4f541b2476ac81',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/home/rwaltenberg/Projects/moneycounter/src/index.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 2,
          column: 32
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      '0': 0
    },
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_1jr5bbbztl.s[0];
angular.module('app', ['ui.router']);